export const GET_GROUP_SETTINGS_REQ = 'GET_GROUP_SETTINGS_REQ';
export const GET_GROUP_SETTINGS_SUCCESS = 'GET_GROUP_SETTINGS_SUCCESS';
export const GET_GROUP_SETTINGS_FAIL = 'GET_GROUP_SETTINGS_FAIL';

export const SAVE_GROUP_SETTINGS_REQ = 'SAVE_GROUP_SETTINGS_REQ';
export const SAVE_GROUP_SETTINGS_SUCCESS = 'SAVE_GROUP_SETTINGS_SUCCESS';
export const SAVE_GROUP_SETTINGS_FAIL = 'SAVE_GROUP_SETTINGS_FAIL';
